// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getDatabase, ref, update, get } from "firebase/database"
import { GoogleAuthProvider } from "firebase/auth"

import { FIREBASE_CONFIG } from "../configs/firebaseConfig.js"
import { consoleLog } from '../utilities/helpers.jsx'

//Firebase documentation: https://firebase.google.com/docs/reference/js/database

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// https://firebase.google.com/docs/web/setup

// Initialize Firebase
const app = initializeApp(FIREBASE_CONFIG)

// const analytics = getAnalytics(app)

export const database = getDatabase(app)
export const googleAuthProvider = new GoogleAuthProvider()

// Get environment-specific database path to avoid overwriting production data
const dbEnvironment = import.meta.env.VITE_MYSQL_DB || "development"

//This determines what is referenced
export const collectiveRef = ref(database, `${dbEnvironment}/collective`) // environment-specific collective reference

/**
 * Merges the given fields into a single user's entry in the Firebase
 * collective (path: `${dbEnvironment}/collective/${username}`). Uses
 * `update()` on the user-specific ref (rather than `set()`, or `update()` on
 * the parent `collectiveRef`) so only the given fields are touched, preserving
 * any existing enrichment data (e.g. community/entity fields synced at login)
 * already stored for that user.
 * @param {string} username - Chaperon username (collective key)
 * @param {Object} updates - Fields to merge into the user's collective entry
 * @returns {Promise<void>}
 */
export const updateCollectiveUser = (username, updates) => {
    const userRef = ref(database, `${dbEnvironment}/collective/${username}`)
    return update(userRef, updates)
}

/**
 * Reads a single user's entry from the Firebase collective.
 * @param {string} username - Chaperon username (collective key)
 * @returns {Promise<Object|null>} The entry, or null if none exists
 */
export const getCollectiveUser = async (username) => {
    const userRef = ref(database, `${dbEnvironment}/collective/${username}`)
    const snapshot = await get(userRef)
    return snapshot.exists() ? snapshot.val() : null
}

consoleLog(`Chaperon Zone initialized for environment: ${dbEnvironment}`)

// export { googleAuthProvider, database as default }
